import { NotificationData, notifications } from '@mantine/notifications';

const successOptions: Partial<NotificationData> = {
  color: 'green',
};

const errorOptions: Partial<NotificationData> = {
  color: 'red',
};

export function notifySuccess(message: string, options: Partial<NotificationData> = {}) {
  return notifications.show({
    message,
    ...options,
    ...successOptions,
  });
}

export function notifyError(error: string | Error, options: Partial<NotificationData> = {}) {
  return notifications.show({
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    message: `${error}`,
    ...options,
    ...errorOptions,
  });
}

export function notifyResult(
  error: Error | null | undefined,
  success: string,
  failed: string,
  options: Partial<NotificationData> = {}
) {
  if (error) {
    return notifications.show({
      message: failed,
      ...options,
      ...errorOptions,
    });
  } else {
    return notifications.show({
      message: success,
      ...options,
      ...successOptions,
    });
  }
}
